import React from "react";

const PersonalContext = React.createContext({});

export const PersonalProvider = PersonalContext.Provider;
export const PersonalConsumer = PersonalContext.Consumer;
export default PersonalContext;
